export const vi = {
    "TRIGGER_LISTEN": "Nghe các kích hoạt",
    "ASSIST_EMPTY_MSG": "Đại lý AI đang nghe cuộc trò chuyện của bạn và sẵn sàng tự động hỗ trợ khi được kích hoạt.",
    "MYBOT_TRIGGET_LISTEN": "Hiện tại không có nhiệm vụ My Bot nào đang hoạt động",
    "MYBOT_EMTPY_MSG": "Để bắt đầu một nhiệm vụ trên My Bot, hãy đi đến tab tìm kiếm và chọn tùy chọn \"Chạy với đầu vào của đại lý\" cho nhiệm vụ mong muốn của bạn.",
    "PROACTIVE_MODE": "Chế độ chủ động",
    "SETTINGS": "Cài đặt",
    "HELP_AND_SUPPORT": "Giúp đỡ và Hỗ trợ",
    "HELP": "Giúp",
    "LANGUAGE": "Ngôn ngữ",
    "THEME": "Chủ đề",
    "AUTOMATIC": "Tự động",
    "FILE_NAME":"Tên tập tin",
    "DARK": "Tối",
    "AUTO_SCROLL_TOOLTIP":"Kiểm soát cuộn tự động của Tab Hỗ trợ, Bot của tôi và Nội dung Tab Bản ghi",
    "LIGHT": "Sáng",
    "THEME_DESC": "Điều này sẽ sử dụng chế độ mặc định của hệ thống của bạn",
    "DOCUMENTATION": "Tài liệu",
    "DOC_DESC": "Xem các bài viết tài liệu chi tiết của chúng tôi.",
    "FAQ_U": "Câu hỏi thường gặp",
    "FAQ_DESC": "Xem các câu hỏi thường gặp về đại lý AI.",
    "KORE_ACADEMY": "Học viện Kore",
    "KORE_ACA_DESC": "Tìm hiểu thêm về đại lý AI bằng cách tham gia các khóa học trong học viện.",
    "SEARCH": "Tìm kiếm",
    "MY_BOT": "My Bot",
    "ASSIST": "Hỗ trợ",
    "TRANSCRIPT": "Biên bản",
    "HISTORY": "Lịch sử",
    "STARTOVER": "Bắt đầu lại",
    "TAB_TEXT":"Không có tab nào được bật! Vui lòng bật ít nhất một tab",
    "RESTART_INPUTS": "Khởi động lại với đầu vào đã ghi lại",
    "ASKCUSTOMER": "Hỏi Khách Hàng",
    "TELLCUSTOMER": "Nói với Khách Hàng",
    "TAP_SEARCH":"Nhấn để tìm kiếm",
    "WELCOME_MSG": "Tin nhắn Chào Mừng",
    "SEND": "Gửi",
    "SENT": "Đã Gửi",
    "AWAITING": "Đang Chờ Phản Hồi | Gõ để tiếp tục",
    "OVERRIDE": "Gõ để tiếp tục",
    "OVERRIDE_FILE": "Đính kèm tệp để tiếp tục",
    "ACCEPT_RESPONSE": "Phản hồi Đã Chấp Nhận",
    "AGENT_ENTERED": "Đại lý đã vào",
    "EXPECTED_FORMAT": "Định dạng Mong Đợi",
    "INPUT_VALUES": "Giá trị Đầu vào",
    "RESTART": "Khởi động lại",
    "START_OVER": "Bắt đầu lại",
    "RESTART_CAPTURE": "Khởi động lại với đầu vào đã ghi lại",
    "CANCEL": "Hủy bỏ",
    "INTERRUPT_DIALOG": "NHIỆT ĐỘNG DIALOG TASK",
    "RUN": "CHẠY",
    "RUN_AGENT": "Chạy với đầu vào của đại lý",
    "STEP": "Bước",
    "DIALOG_TASK": "Nhiệm vụ Hội thoại",
    "FAQ": "Câu hỏi thường gặp",
    "SNIPPET": "Câu trả lời",
    "ARTICLE": "Trang Web",
    "FILE": "Tệp",
    "SUGGESTED": "Đề xuất",
    "ALL_DIALOG": "Tất cả Nhiệm vụ Hội thoại",
    "DIALOG_TEXT": "Hội thoại",
    "INTENT_IDENTIFIED": "Câu nói của Khách Hàng",
    "NOT_WHAT_LOOKING": "Đề xuất Sai?",
    "BOT": "Bot",
    "CUSTOMER": "Khách Hàng",
    "YOU": "Bạn",
    "TERMINATE_CONV": "Kết Thúc Nhiệm Vụ Hội Thoại",
    "TERMINATE_CONV_DESC": "Bạn có chắc chắn muốn kết thúc nhiệm vụ hội thoại không? Đại lý AI sẽ không thể đưa ra các đề xuất nữa.",
    "YES_TERMINATE": "Có, Kết Thúc",
    "NO_CANCEL": "Không, Hủy Bỏ",
    "OVERRIDE_CONTINUE": "Tiếp tục với chế độ ghi đè",
    "SUMMARY_TEXT": "Tóm tắt",
    "SUBMIT": "Gửi",
    "INTERRUPT_OCCURED": "Đã Xảy Ra Gián Đoạn",
    "IDENTIFIED_INTENT": "Ý định đã xác định",
    "INTERRUPT_DESC": "Chạy điều này sẽ kết thúc Nhiệm vụ Hội thoại đang diễn ra của bạn.",
    "ACCEPT_RUN": "Chấp Nhận và Chạy",
    "RUN_LATER": "Chạy Sau",
    "KNOW_MORE": "Biết Thêm",
    "MORE_TEXT": "Nhiều hơn",
    "LESS_TEXT": "Ít hơn",
    "VIEW_MORE": "Xem Thêm",
    "VIEW_LESS": "Xem Ít Hơn",
    "SHOW_MORE_FAQ": "Hiện Thêm Câu Hỏi Thường Gặp",
    "SHOW_LESS_FAQ": "Hiện Ít Hơn Câu Hỏi Thường Gặp",
    "SHOW_MORE_ARTICLE": "Hiện Thêm Trang Web",
    "SHOW_LESS_ARTICLE": "Hiện Ít Hơn Trang Web",
    "SHOW_MORE_SNIPPET": "Hiện Thêm Câu Trả Lời",
    "SHOW_LESS_SNIPPET": "Hiện Ít Hơn Câu Trả Lời",
    "SHOW_MORE_FILES": "Hiện Thêm Tệp",
    "SHOW_LESS_FILES": "Hiện Ít Hơn Tệp",
    "VIEW_ALL_DIALOG": "Xem tất cả Các Hội thoại",
    "VIEW_FEW_DIALOG": "Xem một vài Hội thoại",
    "HELP_FULL": "Có Hữu Ích Không?",
    "THANKYOU": "Cảm ơn!",
    "EXPAND_MORE": "Mở Rộng / Nhiều Hơn",
    "CLOSE_TEXT": "Đóng",
    "STARTED": "Bắt Đầu",
    "ENDED": "Kết Thúc",
    "VIEW_FULL_ARTICLE": "Xem trang web",
    "VIEW_FULL_FILE": "Xem tệp",
    "COPIED": "Đã Sao Chép",
    "SENTI_ANALY": "Phân Tích Tâm Trạng",
    "WRONG_SUGGESTION": "Đề xuất Sai",
    "INCORRECT_INTENT": "Ý định Không Chính Xác",
    "ACCIDENTAL_CLICK": "Nhấp Nhầm",
    "TIME_TAKING": "Tốn Thời Gian",
    "OTHER": "Khác",
    "PLAYBOOK_EMPTY_MSG": "Chọn Kịch bản",
    "PLAYBOOK_EMPTY_DESC": "AI đại lý không thể tải kịch bản vì tất cả các kịch bản có sẵn là động. Nhấp vào 'Chọn Kịch bản' để truy cập kịch bản",
    "STAGE": "Giai Đoạn",
    "PROCEED_TO_CLOSE": "Tiến Hành Đóng",
    "RECOMENDED_PLAYBOOK": "KỊCH BẢN ĐƯỢC ĐỀ XUẤT",
    "PRIMARY_SCRIPTS": "KỊCH BẢN CHÍNH",
    "DYNAMIC_SCRIPTS": "KỊCH BẢN ĐỘNG",
    "RESUME": "Tiếp Tục",
    "ENABLE_CLOSE": "Nhấp vào nút tiếp tục để kích hoạt Giai đoạn Đóng",
    "LIST_VIEW": "Chế Độ Danh Sách",
    "TERMINATE": "Kết Thúc",
    "MINIMIZE": "Thu Nhỏ",
    "MAXIMIZE": "Phóng Đại",
    "NO_SEARCH_RESULT": "Không tìm thấy kết quả tìm kiếm",
    "SENTIMENT_AWAITING": "Đang Chờ Phân Tích Tâm Trạng",
    "POSITIVE": "Tích Cực",
    "NEGATIVE": "Tiêu Cực",
    "ASSOCIATED_WORK_NOTES": "Ghi Chú Giải Quyết Trước Đó",
    "AGENT_JOINED_CONV": "Đại lý đã tham gia cuộc trò chuyện",
    "AUTOSCROLL_ASSIST": "Tự Động Cuộn Nội Dung Thẻ Hỗ Trợ",
    "FILE_SIZE_MSG": "Kích thước tệp phải trong vòng 25MB. Vui lòng thử lại.",
    "OVERRIDE_BTN": "Ghi Đè",
    "CHOOSE_FILE": "Chọn Tệp",
    "SUMMARY_ERROR_TEXT": "Xin lỗi, nhưng đã có một sự cố trong việc tạo tóm tắt cho cuộc trò chuyện này. Vui lòng tạo tóm tắt của riêng bạn.",
    "ASK_A_QUESTION": "Hỏi một câu hỏi",
    "COPY": "Sao Chép",
    "PLAYBOOK": "Sách hướng dẫn",
    "TELL_US_MORE": "Nói cho chúng tôi biết thêm…",
    "THANKS_FEEDBACK": "Cảm ơn bạn đã phản hồi",
    "SOMETHING_WRONG": "Có điều gì đó không đúng",
    "CLICK_ERROR_DETAILS": "Nhấn để xem chi tiết lỗi",
    "NO_ACTIVE_PLAYBOOK": "Không có playbook nào đang hoạt động",
    "REPHRASE_QUESTION": "Bạn có thể diễn đạt lại câu hỏi của mình hoặc hỏi điều gì khác không?",
    "VIEW_FULL_ARTICLE_2": "Xem toàn bộ bài viết",
    "VIEW_FULL_FILE_2": "Xem toàn bộ tệp",
    "INTERNAL_INFO": "Thông tin nội bộ",
    "SOURCES": "Nguồn",
    "CONVERSATION_SUMMARY": "Tóm tắt cuộc trò chuyện",
    "WAITING": "Đang chờ",
    "WIDGET_DISABLED": "Widget đã bị vô hiệu hóa",
    "AI_SETTINGS_DISABLED": "Cài đặt AI đã bị vô hiệu hóa! Vui lòng liên hệ với quản trị viên AI",
    "SERVER_CONNECTION_ERROR": "Lỗi khi kết nối với máy chủ",
    "VIEW": "Xem",
    "ATTACHMENT_INPUT": "Nhập đính kèm",
    "TYPE_SUMMARY": "Nhập tóm tắt",
    "BY":"Bởi",
    GENERATE_SUMMARY: "Tạo tóm tắt",
    PREV_SUMMARIES: "Tóm tắt đã tạo trước đó",
    DIALOG_WORKFLOWS: "Quy trình làm việc hội thoại",
    SHOW_ALL_DIALOG: "Hiển thị tất cả tác vụ hội thoại",
    SHOW_ALL_DIALOGS: "Hiển thị tất cả hội thoại",
    CUSTOM_TAB: "Tab tùy chỉnh",
    AGENT_INPUT: "Đầu vào Agent",
    CUSTOM_EMPTY_MSG: "Không có quy trình làm việc nào đang hoạt động",
    CUSTOM_TAB_DESC: "Để bắt đầu một quy trình làm việc, hãy thực hiện một trong các mục trong danh sách hiện có ở dưới cùng của màn hình.",
    SUBMIT_OVERALL_FEEDBACK: "Gửi phản hồi tổng thể",
    FEEDBACK_POPUP_SUBTITLE: "Phản hồi về widget và các tính năng của nó",
    FEEDBACK_SATISFIED: "Hài lòng",
    FEEDBACK_UNSATISFIED: "Không hài lòng",
    FEEDBACK_PROVIDE_REASONS: "Cho thêm thông tin...",
    FEEDBACK_TITLE: "Phản hồi",
    "AGENTIC_THINKING" : "Đang suy nghĩ",
    "AGENTIC_AGENT_TITLE" : "Đại lý",
    "AGENTIC_COPILOT_MODE_TITLE" : "Chế độ Copilot Agentic",
    "AGENTIC_SENDING_MESSAGE" : "Đang gửi...",
    "AGENTIC_COPILOT_DESC" : "Agentic Copilot đang tích cực lắng nghe cuộc trò chuyện của bạn và sẵn sàng hỗ trợ tự động",
    "AGENTIC_SEARCH_RESULTS" : "Kết quả Tác nhân",
    "PAUSE_AUTO_SEND" : "Tạm dừng Gửi Tự động",
    "PAUSE_AGENTIC" : "Tạm dừng Tác nhân",
    "RESUME_AGENTIC" : "Tiếp tục Tác nhân",
    "RESUME_AUTO_SEND" : "Tiếp tục Gửi Tự động"
}